import React, { useState, useEffect } from "react";

import { generateRandomSchema } from "./Generator/Cat/utils";
import { catExplosion } from "../utils";
import Header from "./Header";
import Footer from "./Footer";
import Info from "./Info";
import Generator from "./Generator";

const App = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [schema, setSchema] = useState(generateRandomSchema());

  useEffect(() => {
    window.addEventListener("click", catExplosion);
    return () => window.removeEventListener("click", catExplosion);
  }, []);

  const onModeToggle = (darkModeEnabled) => {
    setDarkMode(darkModeEnabled);
    localStorage.setItem("theme", darkModeEnabled ? "dark" : "");
  };

  const containerClass = `app-container ${darkMode ? "dark" : ""}`;

  return (
    <div className={containerClass}>
      <div className="dark:bg-gray-800 dark:text-gray-100 w-full min-h-full sm:h-full">
        <div className="m-auto w-full h-full max-w-3xl flex flex-col">
          <Header onModeToggle={onModeToggle} />
          <div className="flex flex-1 align-center items-center">
            <div className="md:flex flex-row w-full p-5 bg-gray-50 dark:bg-gray-700 md:rounded-3xl md:p-10 shadow-xl">
              <div className="flex flex-1 flex-col items-center justify-center">
                <Info />
              </div>
              <div className="flex flex-1 flex-col items-center justify-center md:items-end">
                <Generator
                  action={() => setSchema(generateRandomSchema())}
                  schema={schema}
                />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default App;
